import { IVisualizationPanelOptions } from 'survey-analytics';

export const VISUALIZATION_PANEL_OPTIONS: IVisualizationPanelOptions = {
  allowDynamicLayout: false,
  allowDragDrop: false,
  allowHideQuestions: false,
  allowShowPercentages: true,
  showPercentages: true,
  defaultChartType: 'bar',
  haveCommercialLicense: true,
  stripHtmlFromTitles: true,
};
